export default "__VITE_ASSET__171cd4c1__"